export default __webpack_public_path__ + "static/media/menu-bg-moon.ead4a487.jpg";